import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { GeneralService } from 'src/app/Service/general.service';
import { SubscriptionPlanComponent } from 'src/app/user/subscription-plan/subscription-plan.component';
import Swal from 'sweetalert2';
import { AddCallAlertFormComponent } from '../add-call-alert-form/add-call-alert-form.component';
class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Component({
    selector: 'app-call-alert',
    templateUrl: './call-alert.component.html',
    styleUrls: ['./call-alert.component.scss'],
})
export class CallAlertComponent implements OnInit {
    @ViewChild('content', { static: false }) content: TemplateRef<any>;
    currentUser: any;
    isLoading: boolean = false;
    callAlertForm: FormGroup;
    usersData: any;
    userId: any;
    callAlertTypes: any[] = [];
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective, { static: false })
    dtElement: DataTableDirective;
    dtTrigger = new Subject<any>();
    breadCrumbItems: Array<{}>;
    constructor(
        private dialog: MatDialog,
        private router: Router,
        private service: GeneralService,
        private http: HttpClient,
        private datePipe: DatePipe,
        private fb: FormBuilder
    ) {
        if (this.router.getCurrentNavigation()) {
            if (this.router.getCurrentNavigation().extras.state) {
                const state = this.router.getCurrentNavigation().extras.state;
                this.userId = state['id'];
            } else {
                console.log(
                    "localStorage.getItem('UserId')",
                    localStorage.getItem('UserId')
                );
                if (localStorage.getItem('UserId')) {
                    this.userId = localStorage.getItem('UserId');
                    this.router.navigate(
                        ['/users/users-users-details/call-alert'],
                        {
                            state: { id: localStorage.getItem('UserId') },
                        }
                    );
                } else {
                    this.router.navigate(['/users/users-users']);
                }
            }
        }
    }

    ngOnInit() {
        this.currentUser = this.service.getcurrentUser();
        this.getCallAlertType();
        this.callAlertForm = this.fb.group({
            call_alert_type_id: new FormControl(null, Validators.required),
            call_type: new FormControl(null, Validators.required),
            reference_source: new FormControl(null, Validators.required),
            priority: new FormControl(null, Validators.required),
            follow_up_date: new FormControl(Date, Validators.required),
            call_remarks: new FormControl(null, Validators.required),
        });
        if (this.userId) {
            this.getUsersCallDetails();
        } else {
            this.router.navigate(['/users/users-user']);
        }

        this.breadCrumbItems = [
            { label: 'Users List', path: '/users/users-users' },
            { label: 'User Details', path: '/users/users-users-details' },
            {
                label: 'Call Alert',
                path: '/users-users-details/call-alert/',
                active: true,
            },
        ];
        this.dtOptions = {
            pagingType: 'simple_numbers',
            pageLength: 10,
            processing: true,
            serverSide: true,
            ordering: false,
            ajax: (dataTablesParameters: any, callback) => {
                this.isLoading = true;
                this.http
                    .get<DataTablesResponse>(
                        `${this.service.getCallAlertList(this.userId)}/${
                            dataTablesParameters.search.value != ''
                                ? dataTablesParameters.search.value + '/'
                                : ''
                        }${
                            (dataTablesParameters.start +
                                dataTablesParameters.length) /
                            dataTablesParameters.length
                        }/${dataTablesParameters.length}`,
                        {}
                    )
                    .subscribe((resp: any) => {
                        if (resp.total_count) {
                            callback({
                                recordsTotal: resp.total_count,
                                recordsFiltered: `${
                                    resp.data[0].filtercount
                                        ? resp.data[0].filtercount
                                        : resp.total_count
                                }`,
                                data: resp.data,
                            });
                            this.isLoading = false;
                        } else {
                            callback({
                                recordsTotal: resp.total_count,
                                recordsFiltered: resp.total_count,
                                data: resp.data,
                            });
                            this.isLoading = false;
                        }
                    });
            },
            responsive: true,
            columns: [
                {
                    title: 'Sr.No.',
                    data: null,
                    render: (data, type, row, meta) => {
                        return meta.row + 1;
                    },
                },
                {
                    title: 'Call Initiated From',
                    data: null,
                    render: (data) => {
                        return data.call_initiated_from;
                    },
                },
                {
                    title: 'Alert Type',
                    data: null,
                    render: (data) => {
                        return data.alert_type;
                    },
                },
                {
                    title: 'Activation Status',
                    data: null,
                    render: (data) => {
                        return data.activation_status;
                    },
                },
                {
                    title: 'Call Type',
                    data: null,
                    render: (data) => {
                        return data.call_type;
                    },
                },
                {
                    title: 'Last Call Date And Time',
                    data: null,
                    render: (data) => {
                        return this.datePipe.transform(
                            data.call_date,
                            'dd/MM/yyyy hh:mm  a',
                            'UTC'
                        );
                    },
                },
                {
                    title: 'Next Follow Up Date And Time',
                    data: null,
                    render: (data) => {
                        if (
                            data.follow_up_date == '' ||
                            data.follow_up_date == null ||
                            data.follow_up_date == '0000-00-00 00:00:00'
                        ) {
                            return 'N/A';
                        } else {
                            var date = new Date(data.follow_up_date);
                            return this.datePipe.transform(
                                date,
                                'dd/MM/yyyy hh:mm  a',
                                'UTC'
                            );
                        }
                    },
                },
                {
                    title: 'Called By',
                    data: null,
                    render: (data) => {
                        return data.csrName;
                    },
                },
                // {
                //   title: 'Remarks',
                //   data: null,
                //   width: '200px',
                //   render(data) {
                //     return data.call_remarks;
                //   },
                // },
            ],
            createdRow: (row: Node, data: any) => {
                this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                    const remarksContent = this.createRemarksContent(
                        data.call_remarks
                    );
                    const purposeContent = this.createPurposeContent(
                        data.purpose
                    );

                    // Combine both into one child row
                    const combinedContent = `
            <div>
            ${purposeContent}
            ${remarksContent}
            </div>
          `;

                    // Attach combined child content
                    const childRow = dtInstance
                        .row(row)
                        .child(combinedContent)
                        .show();

                    console.log('Child row content:', combinedContent);
                });

                // If you later need to add event listeners for buttons in child rows:
                // $(row).find('.receipt').on('click', (e) => {
                //   this.router.navigate([
                //     'user/receipts/' + e.target.getAttribute('UserId'),
                //   ]);
                // });
            },
        };
    }
    createPurposeContent(purpose: string | null | undefined): string {
        const safePurpose = purpose ? purpose : '--';
        const formattedPurpose = safePurpose.replace(/(.{150})/g, '$1<br/>');
        return `
    <tr class="purpose-row" style="padding-bottom: 20px;">
      <td colspan="9" style="word-break: break-word; white-space: normal;">
        <strong>Purpose:&nbsp;</strong>${formattedPurpose}
      </td>
    </tr><br/>`;
    }

    createRemarksContent(remarks: string | null | undefined): string {
        const safeRemarks = remarks ? remarks : '--';
        const formattedRemarks = safeRemarks.replace(/(.{150})/g, '$1<br/>');
        return `
    <tr class="remarks-row">
      <td colspan="9" style="word-break: break-word; white-space: normal;">
        <strong>Remarks:&nbsp;</strong>${formattedRemarks}
      </td>
    </tr>`;
    }
    rerender(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next();
        });
    }

    ngAfterViewInit() {
        this.dtTrigger.next();
    }
    getUsersCallDetails() {
        this.isLoading = true;
        this.service.getUsersCallDetails(this.userId).subscribe(
            (res: any) => {
                if (res) {
                    this.usersData = res.data;
                    this.isLoading = false;
                }
            },
            (error) => {
                this.isLoading = false;
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        );
    }

    getCallAlertType() {
        this.isLoading = true;
        this.service.getCallAlertType().subscribe(
            (res: any) => {
                if (res) {
                    this.callAlertTypes = res.data;
                    this.isLoading = false;
                }
            },
            (error) => {
                this.isLoading = false;
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        );
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(AddCallAlertFormComponent, {
            width: '600px',
            autoFocus: false,
            maxHeight: '90vh',
            disableClose: true,
        });
        dialogRef.componentInstance.userId = this.userId;
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.getUsersCallDetails();
                this.rerender();
            }
        });
    }
    close() {
        this.dialog.closeAll();
    }
}
